export const FILTER_VALUE_EMPTY: number = 0;
export const FILTER_VALUE_EXTRA: number = -1;
